import { Component, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Action } from '@fullcalendar/core/internal';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Engagement } from 'src/app/shared/models/Engagement';
import { PtaSousActivite } from 'src/app/shared/models/ptasousactivite';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-engagement',
  templateUrl: './engagement.component.html',
  styleUrl: './engagement.component.scss'
})


export class EngagementComponent {

  // breadcrumb items
  breadCrumbItems: Array<{}>;

  submitted: boolean;
  sousActiviteItem: PtaSousActivite;
  isLoading: boolean = false;
  items: any = [];
  showFiltre: boolean = false;
  directionItems: any = [];
  selectedDirection: any ;
  userInfo: any
  itemsNonEngager: any = [];
  modalRef: NgbModalRef | null = null;
  item: Engagement = new Engagement();
  itemToDelete!: Action;
  name: any;

  itemsListCopy: any[] = [];
  projetItems: any = [];
  annee: any;
  selectedProjet: any;
  directionId: any;
  @ViewChild('engagementModal') modalContent!: TemplateRef<any>;
  projetId: any;
  firstProjets = 0;
  rowsProjets = 10;
  paginatedProjets = [];
  totalRecords: number = 0; // Nombre total d'éléments
  firstActivites = 0;
  rowsActivites = 10;
  paginatedActivites = [];

  totalRecords1: number = 0; // Nombre total d'éléments

  constructor(
    private modalService: NgbModal,
    public formBuilder: UntypedFormBuilder,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService
  ) { }

  ngOnInit(): void {
    this.projetId = this.localstorage.getProjetToUser();
    this.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();
    this.userInfo = this.localstorage.getInfoUserToService();

    if (this.userInfo?.data?.groupe === "admin") {
      this.showFiltre = true;
      this.getDirection();
      this.getProjetsList();
    }

    if (this.userInfo?.data?.groupe === "point_focal") {
      this.directionId = this.localstorage.getInfoUserToService()?.data?.direction_id;
      this.getProjetByDirection(this.directionId);
    }

    if (this.userInfo?.data?.groupe !== "admin" && this.userInfo?.data?.groupe !== "point_focal") {
      this.getProjetsList();
    }

    this.getTacheEngagementNonEngagement();
  }

  //process selected Projet
  processSelectedProjet() {

    //get sous activites associated
    this.getTacheEngagementNonEngagement();

    //get direction associated
    if (this.selectedProjet) {
      this.getDirectionByProjet(this.selectedProjet);
    }

  }//end processSelectedProjet


  //listing des projets
  getProjetsList() {
    this.paramservice.getListUserProjects(this.userInfo?.data?.reference).subscribe(
      (response: any) => {
        this.projetItems = response.data;
      },
      (error) => {
      }
    )
  }//end getProjetsList


  //list direction par projet
  getDirectionByProjet(reference: any) {
    this.paramservice.getDirectionsByProjet(reference).subscribe(
      (response: any) => {
        this.directionItems = response.data;
      },
      (error: any) => {
      }
    )
  }//end getProjetByDirection

  //filtre les donnees par direction
  filterDataByDirections() {
    this.getTacheEngagementNonEngagement();
  }//en filterDataByDirections


  getSousActiviteToUserEngager(item: any) {
    this.items = [];
    this.isLoading = true;
    //this.ngxService.start();

    this.paramservice.getSousActiviteToProjet(item).subscribe(

      (response: any) => {
        this.isLoading = false;
        this.ngxService.stop();
        this.items = response.data;

        this.totalRecords = this.items.length;
        this.updatePaginatedProjets();

      },
      (error) => {
        this.ngxService.stop();
        //   this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail:"une erreur est survenu lors de la recuperation de la liste des engagements", life: 3000 });
      }
    );
  }//end getSousActiviteToUser


  getSousActiviteToUserNonEngager(item: any) {
    this.itemsNonEngager = [];
    this.isLoading = true;
    this.paramservice.getSousActiviteToProjetNonEngage(item).subscribe(

      (response: any) => {
        this.isLoading = false;
        this.itemsNonEngager = response.data;
        this.totalRecords1 = this.itemsNonEngager.length
        this.updatePaginatedActivites();
        this.ngxService.stop();

        // this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail:response.message, life: 3000 });
      },
      (error) => {
        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: "une erreur est survenu lors de la recuperation de la liste des engagements", life: 3000 });
      }
    );
  }//end getSousActiviteToUser

  DetailEngagement(sousActivite: PtaSousActivite) {

    console.log("sousActivite", sousActivite);

    // Ouvrir le modal en passant le template
    if (sousActivite instanceof PtaSousActivite) {
      this.sousActiviteItem = sousActivite;
    } else {
      this.sousActiviteItem = Object.assign(new PtaSousActivite(), sousActivite);
    }

    //this.item.pta_sous_activite_id = sousActivite.reference;
    this.modalService.open(this.modalContent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
  }//end DetailEngagement

  fileName: string = '';


  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.item.preuve = file;

    }
  }
  //get list fo pelpelelel
saveEngagement() {

  // Vérification date vide
  if (!this.sousActiviteItem.date_engagement) {
    this.messageService.add({
      severity: 'info',
      summary: 'X-Project',
      detail: "Veuillez renseigner la date d'engagement"
    });
    return;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const engagementDate = new Date(this.sousActiviteItem.date_engagement);

  // Vérification date invalide
  if (isNaN(engagementDate.getTime())) {
    this.messageService.add({
      severity: 'error',
      summary: 'X-Project',
      detail: "La date d'engagement est invalide"
    });
    return;
  }

  engagementDate.setHours(0, 0, 0, 0);

  // Vérification date future
  if (engagementDate > today) {
    this.messageService.add({
      severity: 'info',
      summary: 'X-Project',
      detail: "La date d'engagement ne peut pas être ultérieure à aujourd'hui"
    });
    return;
  }

  // Vérification métier
  if (!this.sousActiviteItem.canSaveEngagement()) {
    this.messageService.add({
      severity: 'info',
      summary: 'X-Project',
      detail: this.sousActiviteItem.getErrorMessage()
    });
    return;
  }

  const formdata = new FormData();

  formdata.append('total_engage', this.sousActiviteItem.total_engage);
  formdata.append('mt_budgetise', this.sousActiviteItem.total);
  formdata.append('date_engagement', this.sousActiviteItem.date_engagement);
  formdata.append('reference', this.sousActiviteItem.reference);
  formdata.append('no_fiche', this.item.no_fiche);
  formdata.append('no_contrat', this.item.no_contrat);

  if (this.item.preuve) {
    formdata.append('preuve', this.item.preuve);
  }

  console.log("this.sousActiviteItem", this.sousActiviteItem);

  this.ngxService.start();

  this.paramservice.saveEngagement(formdata).subscribe(
    (response: any) => {

      this.ngxService.stop();

      this.messageService.add({
        severity: 'success',
        summary: 'X-Project',
        detail: response.message
      });

      this.modalService.dismissAll();

      this.getTacheEngagementNonEngagement();

      this.sousActiviteItem = new PtaSousActivite();

    },
    (error) => {

      this.ngxService.stop();

      this.messageService.add({
        severity: 'error',
        summary: Constant.suiviTitle,
        detail: error.error.message
      });

    }
  );

}
  confirm1(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Êtes-vous sûr de vouloir continuer?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: 'Vous avez acepter' });
        this.paramservice.deleteAction(event).subscribe(
          (response: any) => {
          },
          (error) => {
          },
        )
      },
    });
  }//end confirm1


  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.items.slice(start, end);
  }

  onPageChangeProjets(event: any) {
    this.firstProjets = event.first;
    this.rowsProjets = event.rows
    this.updatePaginatedProjets();
  }

  updatePaginatedActivites() {
    const start = this.firstActivites;
    const end = start + this.rowsActivites;
    this.paginatedActivites = this.itemsNonEngager.slice(start, end);
  }
  onPageChangeActivites(event: any) {
    this.firstActivites = event.first; // event.first représente le premier index de la page
    this.rowsActivites = event.rows;   // event.rows représente le nombre de lignes par page
    this.updatePaginatedActivites();
  }

  //
  AnnulerEngagement(event: any) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Êtes-vous sûr de vouloir annuler cet engagement',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();
        this.paramservice.annulationEngagement(event.reference).subscribe(
          (response: any) => {
            this.ngxService.stop();
            this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: 'L\'engagement a été annulé' });
            this.getTacheEngagementNonEngagement()
          },
          (error: any) => {
            this.ngxService.stop();
            this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: error.error.message || "une erreur est survenu", life: 3000 });
          },
        )
      },
    });
  }



  getDirection() {

    this.paramservice.fetchDataDirection().subscribe(
      (response: any) => {
        this.directionItems = response.data;
      },
      (error) => {
      }
    )
  }
  getProjetByDirection(reference: any) {
    this.paramservice.getProjetByDirection(reference).subscribe(
      (response: any) => {
        this.projetItems = response.data;
      },
      (error: any) => {
      }
    )
  }


  getTacheEngagementNonEngagement() {
    this.ngxService.start();

    const request = {
      "user_ref": this.userInfo?.data?.reference,
      "programme_id": this.selectedProjet || null,
      "annee": this.annee,
      "direction_id": this.selectedDirection || this.directionId || null,
    }

    this.getSousActiviteToUserEngager(request);
    this.getSousActiviteToUserNonEngager(request);

  }


  exportToDocument(item: any) {

    if (!item) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Attention',
        detail: 'Aucun élément sélectionné'
      });
      return;
    }


    this.ngxService.start();

    this.paramservice.downloadFicheEngagement(item.reference).subscribe(
      (response: Blob) => {

        //  définir extension dynamique
        const extension = 'pdf';
        const filename = `engagement.${extension}`;

        // téléchargement
        FileSaver.saveAs(response, filename);

        // ouverture auto seulement pour PDF
        const url = URL.createObjectURL(response);
        window.open(url, '_blank');

        this.ngxService.stop();

        this.messageService.add({
          severity: 'success',
          summary: 'Succès',
          detail: `Fichier ${extension.toUpperCase()} téléchargé`,
          life: 3000
        });

      },
      (error) => {
        this.ngxService.stop();

        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Téléchargement échoué',
        });
      }
    );
  }
}
